import React from 'react';
import {subscribeToWhiteboards} from '../../../firebase/firestore/whiteboards';

export const useWhiteboards = () => {
    const [whiteboards, setWhiteboards] = React.useState([]);
    const [loading, setLoading] = React.useState(true);
    const [error, setError] = React.useState(null);

    React.useEffect(() => {
        const unsubscribe = subscribeToWhiteboards(
            (data) => {
                setWhiteboards(data || []);
                setLoading(false);
            },
            (err) => {
                setError(err);
                setLoading(false);
            }
        );

        return () => unsubscribe();
    }, []);

    return {whiteboards, loading, error};
};

